<template>
  <div class="common_header_type_2">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="common_header_type_2_inner">
                    <div class="left_area">
                        <h3>{{ mainTitle }}</h3>
                    </div>
                    <div class="right_area">
                        <div class="mr_10">{{ moduleTitle }} <span v-if="subTitle">: {{ subTitle }}</span> </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name:'BreadcrumbComponent',
    props: {
        moduleTitle: {
            type: String,
            required: false,
        },
        mainTitle: {
            type: String,
            required: false,
        },
        subTitle: {
            type: String,
            required: false,
        },
    },
    computed: {
        
    },
    data() {
        return {
            
        }
    },
    watch: {
        
    },
    methods: {
        
    }
}
</script>